import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { useProductAttributeStore } from "../../hooks/useProductAttributeStore";
import { ProductAttributeModal } from "./components/ProductAttributeModal";
import CategoryIcon from '@mui/icons-material/Category';
import { SpecificAttributesModal } from "./components/SpecificAttributesModal";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    { type: 'text', field: 'type_name', label: 'Tipo', align:'center' },
    // { type: 'text', field: 'createdby', label: 'Definido por', align:'center' },
    { type: 'text', field: 'status', label: 'Estado', align:'center', format:(row) => row.status == 1 ? 'Activado' : 'Desactivado' },
    { type: 'detail', field: 'detail', label: 'Detalle', align:'center' },
];

export const ProductAttributesView = () => {

    const navigate = useNavigate();
    // const { search } = useSelector(selectHeaderState);

    const { setActionAttribute, getproductAttribute, getproductAttributeByCompany, deleteproductAttribute, changeStatusproductAttribute } = useProductAttributeStore();

    const [loading, setLoading] = useState(false);
    const [attributes, setAttributes] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [showAttributesSpecifcModal, setShowAttributespecificModal] = useState<boolean>(false);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    useEffect(() => {
        getproductAttributeApi()
    },[])

    const getproductAttributeApi = async(search='') => {
        try {
            setLoading(true);
            const response = await getproductAttributeByCompany(search);
            if(!response){
                setAttributes([]);
                setLoading(false);
                return false;
            }else{
                setAttributes(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onAdd = () => {
        setActionAttribute('add');
        setShowModal(true);
    }
    const onEdit = (rowSelected:any) => {
        setActionAttribute('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDelete = (rowSelected:any) => {
        setActionAttribute('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
    const onDetails = (rowSelected:any) => {
        setActionAttribute('detail');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onSwitch = async(rowSelected) => {
        const statusrow = rowSelected?.status == '0' ? '1' : '0';
        setLoading(true);
        const response:any = await changeStatusproductAttribute(rowSelected.id, {status:statusrow});
        if(response){
            getproductAttributeApi();
            setLoading(false);
            setRowSelected('');
        }else{
            setLoading(false);
            return false;
        }
    }

    const showAttributesSpecifc = (rowSelected) => {
        setRowSelected(rowSelected);
        setShowAttributespecificModal(true);
    }

    const onDeleteConfirm = async() => {
        if (rowSelected) {
            setLoading(true);
            const response = await deleteproductAttribute(rowSelected.id)
            if(response){
                getproductAttributeApi();
                setShowModalConfirm(false);
                setRowSelected('');
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getproductAttributeApi(term)}, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('');
    }

    return (
        <>
            <Grid item xs={12}>
                <CustomTable 
                    title={'Atributos de Producto'}
                    columns={columns} 
                    loading={loading}
                    rows={attributes || []}
                    onRowClick={() => {}}
                    hasOptions
                    onAddFn={onAdd}
                    onAddFnName={'Agregar'}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    onHelper={showAttributesSpecifc}
                    icon_helper={ <CategoryIcon fontSize="small" /> }
                    tooltip_helper={'atributos específicos'}
                    onSwitch={onSwitch}
                    onSearch={onSearch}
                    dense
                />
            </Grid>
            {
                showModal && (
                    <ProductAttributeModal
                        open = {showModal}
                        closeModal = {() => {setShowModal(false)}}
                        attributeSelected = {rowSelected}
                        listAttribute = {getproductAttributeApi}
                        clearState = {clearState}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={()=>{ setShowModalConfirm(false); clearState()}}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                        clearState = {clearState}
                    />
                )
            }
            {
                showAttributesSpecifcModal && (
                    <SpecificAttributesModal
                        open={showAttributesSpecifcModal}
                        closeModal={()=>{ setShowAttributespecificModal(false)}}
                        useSelected = {rowSelected}
                        clearState = {clearState}
                    />
                )
            }
        </>
    )
}